<script>
import api from "@/axios"
import Loader from "../components/loader"
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import ProdutosTable from './posicionamento-table'
import appConfig from "@/app.config"
import Swal from "sweetalert2"

import { produtosChart1, produtosChart2 } from "../components/data-simulados";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Endereçamento",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, ProdutosTable, Loader },
  mounted() {
    console.log('mounted produtos-list_0')
    this.atualizaDataList()
  },
  data() {
    return {
      title: 'Endereçamentos',
      items: [
        {
          text: 'Estoque',
          href: '/movcompras/list',
        },
        {
          text: 'Endereçamentos',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      produtosList: null,
      prodsChart1: produtosChart1,
      prodsChart2: produtosChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
    }
  },

  methods: {
    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/produtos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        this.produtosList = res.data.data

        this.produtosList.forEach((value) => {

          if (value.imgs){
            let imgTrat = value.imgs.split(',')
            value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          }
        })


        this.title = `(${this.produtosList.length}) Endereçamento de Estoque`
        this.loadingList = false
        this.loadingGraph = false
      });
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/produto`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },


  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-8">
                <div class="text-sm-end">

                  <router-link :to="`/produto/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Novo Produto
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <ProdutosTable v-if="!loadingList"
                           :produtosList="produtosList"
                           @deletareg="deletaReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>


    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Endereçamentos de estoque</h4>
            <p class="card-title-desc">Produtos novos ou perto de seu vencimento</p>

            <!-- 16:9 aspect ratio -->
            <div class="ratio ratio-16x9">
              <iframe class="embed-responsive-item" src="https://py-3dpacking.onrender.com/page-3"></iframe>
            </div>
          </div>
        </div>
      </div>

    </div>

  </Layout>
</template>
